import { tokens } from "styles/Tokens";
import { accessTypes } from "utils/CommonConstants";
import { planTypes } from "utils/Types";
import NoPropertyPlansBanner from "../IndividualProperty/NoPropertyPlansBanner";
import AddNewSection from "./AddNewSection";
import { Filters } from "./Filters";
import Item from "./Item/index";

export default function Sections({ selectedPlanDetail, planType }: any) {
  return (
    <>
      <Filters selectedPlanDetail={selectedPlanDetail} planType={planType} />
      {selectedPlanDetail?.sections?.length > 0 ? (
        selectedPlanDetail?.sections?.map((section: any, index: number) => {
          return (
            <Item
              key={section.id}
              section={section}
              index={index}
              planType={planType}
              planId={selectedPlanDetail?.id}
            />
          );
        })
      ) : (
        <NoPropertyPlansBanner bgColor={tokens.Background.General.Primary} message={"You have no Results"} />
      )}

      {planType === planTypes.MyPlans && <AddNewSection label="Add new section" accessType={accessTypes.update} />}
    </>
  );
}
